
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCodeNotReceivedIcn = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21 1.5H3A2.503 2.503 0 0 0 .5 4v11A2.503 2.503 0 0 0 3 17.5h1v3.978a1.016 1.016 0 0 0 .634.95.98.98 0 0 0 1.08-.236l4.5-4.692H21a2.503 2.503 0 0 0 2.5-2.5V4A2.503 2.503 0 0 0 21 1.5ZM22.5 15a1.502 1.502 0 0 1-1.5 1.5H10a.499.499 0 0 0-.36.154L5 21.478V17a.5.5 0 0 0-.5-.5H3A1.502 1.502 0 0 1 1.5 15V4A1.502 1.502 0 0 1 3 2.5h18A1.502 1.502 0 0 1 22.5 4v11Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.538 6.309A.5.5 0 0 0 5 7h5a.5.5 0 0 0 0-1H5a.5.5 0 0 0-.462.309ZM15.462 12.691A.5.5 0 0 0 15 12H5a.5.5 0 0 0 0 1h10a.5.5 0 0 0 .462-.309ZM17.462 9.691A.5.5 0 0 0 17 9H5a.5.5 0 1 0 0 1h12a.5.5 0 0 0 .462-.309Z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M21 1.5H3C2.3372 1.50078 1.70177 1.76442 1.2331 2.2331C0.764423 2.70177 0.500781 3.3372 0.5 4V15C0.500781 15.6628 0.764423 16.2982 1.2331 16.7669C1.70177 17.2356 2.3372 17.4992 3 17.5H4V21.4776C3.99814 21.6814 4.05764 21.881 4.17076 22.0506C4.28388 22.2201 4.44539 22.3517 4.6343 22.4282C4.81717 22.502 5.01803 22.519 5.21068 22.4769C5.40333 22.4349 5.57884 22.3357 5.7143 22.1924L10.2134 17.5H21C21.6628 17.4992 22.2982 17.2356 22.7669 16.7669C23.2356 16.2982 23.4992 15.6628 23.5 15V4C23.4992 3.3372 23.2356 2.70177 22.7669 2.2331C22.2982 1.76442 21.6628 1.50078 21 1.5ZM22.5 15C22.4996 15.3977 22.3414 15.779 22.0602 16.0602C21.779 16.3414 21.3977 16.4996 21 16.5H10C9.93259 16.5 9.86589 16.5136 9.80388 16.5401C9.74187 16.5665 9.68584 16.6052 9.63915 16.6538L5 21.4776V17C5.00004 16.9343 4.98713 16.8693 4.96202 16.8086C4.93691 16.7479 4.90008 16.6928 4.85364 16.6464C4.8072 16.5999 4.75207 16.5631 4.69139 16.538C4.63071 16.5129 4.56567 16.5 4.5 16.5H3C2.60231 16.4996 2.22103 16.3414 1.93982 16.0602C1.65861 15.779 1.50044 15.3977 1.5 15V4C1.50044 3.60231 1.65861 3.22103 1.93982 2.93982C2.22103 2.65861 2.60231 2.50044 3 2.5H21C21.3977 2.50044 21.779 2.65861 22.0602 2.93982C22.3414 3.22103 22.4996 3.60231 22.5 4V15Z\" fill=\"black\"/>\r\n<path d=\"M4.53798 6.30861C4.51287 6.36929 4.49996 6.43433 4.5 6.5C4.49996 6.56567 4.51287 6.63071 4.53798 6.69139C4.56309 6.75207 4.59992 6.8072 4.64636 6.85364C4.6928 6.90008 4.74793 6.93691 4.80861 6.96202C4.86929 6.98713 4.93433 7.00004 5 7H10C10.1326 7 10.2598 6.94732 10.3536 6.85355C10.4473 6.75979 10.5 6.63261 10.5 6.5C10.5 6.36739 10.4473 6.24021 10.3536 6.14645C10.2598 6.05268 10.1326 6 10 6H5C4.93433 5.99996 4.86929 6.01287 4.80861 6.03798C4.74793 6.06309 4.6928 6.09992 4.64636 6.14636C4.59992 6.1928 4.56309 6.24793 4.53798 6.30861Z\" fill=\"black\"/>\r\n<path d=\"M15.462 12.6914C15.4871 12.6307 15.5 12.5657 15.5 12.5C15.5 12.4343 15.4871 12.3693 15.462 12.3086C15.4369 12.2479 15.4001 12.1928 15.3536 12.1464C15.3072 12.0999 15.2521 12.0631 15.1914 12.038C15.1307 12.0129 15.0657 12 15 12H5C4.86739 12 4.74021 12.0527 4.64645 12.1464C4.55268 12.2402 4.5 12.3674 4.5 12.5C4.5 12.6326 4.55268 12.7598 4.64645 12.8536C4.74021 12.9473 4.86739 13 5 13H15C15.0657 13 15.1307 12.9871 15.1914 12.962C15.2521 12.9369 15.3072 12.9001 15.3536 12.8536C15.4001 12.8072 15.4369 12.7521 15.462 12.6914Z\" fill=\"black\"/>\r\n<path d=\"M17.462 9.69139C17.4871 9.63071 17.5 9.56567 17.5 9.5C17.5 9.43433 17.4871 9.36929 17.462 9.30861C17.4369 9.24793 17.4001 9.1928 17.3536 9.14636C17.3072 9.09992 17.2521 9.06309 17.1914 9.03798C17.1307 9.01287 17.0657 8.99996 17 9H5C4.86739 9 4.74021 9.05268 4.64645 9.14645C4.55268 9.24021 4.5 9.36739 4.5 9.5C4.5 9.63261 4.55268 9.75979 4.64645 9.85355C4.74021 9.94732 4.86739 10 5 10H17C17.0657 10 17.1307 9.98713 17.1914 9.96202C17.2521 9.93691 17.3072 9.90008 17.3536 9.85364C17.4001 9.8072 17.4369 9.75207 17.462 9.69139Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/codeNotReceivedIcn.02901ae406fac214f59d9bb356f403ec.svg"),
        {
          React: SvgCodeNotReceivedIcn,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      